<template>
    <div class="formScreen">
        <el-form class="custom-out-form" :model="formScreen" label-width="100px" inline ref="formScreen">
            <el-row type="flex" justify="space-between">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        v-model="formScreen.startTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        v-model="formScreen.endTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="处理状态" prop="exceptionResult">
                    <el-select v-model="formScreen.exceptionResult" placeholder="请选择">
                        <el-option
                            v-for="item in listExamine"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <div class="search-box">
                    <el-form-item label=" " prop="searchString">
                        <el-input v-model="formScreen.searchString" 
                            @change="queryForm"
                            placeholder="请输入国内单号或订单ID"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="queryForm">搜索</el-button>
                    <el-button type="primary" @click="resetForm">重置</el-button>
                </div>
            </el-row>
        </el-form>
        <el-divider></el-divider>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "formScreen",
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            listExamine: [
              { value: 0, label: '未处理' },
              { value: 1, label: '申请退件' },
              { value: 3, label: '申请转库存' },
              { value: 5, label: '申请取消异常' },
              { value: 9, label: '申请转未知' }
            ],
            formScreen: {
                branchCompanyId: "",
                companyId: "",
                startTimeString: "",
                endTimeString: "",
                searchString: "",
                type: "",
                exceptionResult: ''
            },
        };
    },
    mounted() {
        // 初始化默认日期范围（近3个月）
        this.initDefaultDateRange();
        // 自动触发搜索
        this.queryForm();
    },
    methods: {
        // 初始化默认日期范围（近3个月）
        initDefaultDateRange() {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 3);

            this.formScreen.startTimeString = this.formatDateTime(startDate);
            this.formScreen.endTimeString = this.formatDateTime(endDate);
        },

        // 格式化日期时间为 YYYY-MM-DD HH:mm:ss
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        queryForm(type) {
            this.$emit("confirm", this.formScreen, type);
        },
        resetForm() {
            this.$refs.formScreen.resetFields();
            this.$emit("resetSonCompany");
            this.queryForm("reset");
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then((res) => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listBranch = data;
                }
            });
        },
        selectChange(id) {
            this.$emit("resetSonCompany");
            this.formScreen.companyId = "";
            this.$emit("formChange", id);
        },
    },
};
</script>

<style lang="scss" scoped>
.formScreen {
    .custom-out-form {
        .el-form-item {
            margin: 0;
        }
        .search-box {
            display: flex;
            align-items: center;
            .el-form-item {
                margin-right: 10px;
            }
            /deep/ .el-form-item__content {
                width: 300px;
            }
        }
    }
}
</style>
